export enum CalcTypeEnum {
  SIMPLE_SUM = 'SIMPLE_SUM',
}

export enum DeliveryPaymentStatus {
  QUEUED = 'QUEUED',
  PROCESSING = 'PROCESSING',
  DONE = 'DONE',
  FAILED = 'FAILED',
  CANCELED = 'CANCELED',
}

export interface DeliveryPayment {
  id: string;
  carrier_type: string;
  status: DeliveryPaymentStatus;
  created_at: Date | null;
  updated_at: Date | null;
  is_deleted: boolean;
  calc_type: string;
  input: Record<string, any>;
  seller_group_id: string;
  start_process_at: Date | null;
  finish_process_at: Date | null;
  deliveries_count: number | null;
  end_date: Date | null;
  start_date: Date | null;
  audit_price_amount: number | null;
  quoted_price_amount: number | null;
  final_price_amount: number | null;
}

export interface DeliveryPaymentCreate {
  sellers_ids: string[];
  calc_type: CalcTypeEnum;
  start_date: Date;
  end_date: Date;
  user_timezone: string;
  seller_group_id: string;
}
